const toggleItems = document.querySelectorAll('.toggle-section .toggle-item'),
  toggleImages = document.querySelectorAll('.toggle-section .toggle-image');

const toggleSection = document.querySelector('.toggle-section');
const toggleDelay = parseInt(toggleSection.dataset.delay) * 1000;
const prevIcon = {
  icon: null
};

let currentIndex = 0;
let intervalId;

let hasScrolled = false;

function toggleHandler(itemIndex, elements) {
  elements.forEach((item, index) => {
    if (index + 1 == itemIndex) {
      item.classList.add('is-active');

      if (item.classList.contains('toggle-item')) {
        updateToggleIconBorder(item.querySelector('.toggle-icon'));
      }
    } else {
      item.classList.remove('is-active');
    }
  });
}

function updateToggleIconBorder(toggleIcon) {
  if (prevIcon.icon) {
    prevIcon.icon.style.border = '';
    prevIcon.icon.style.borderImage = 'initial';
    prevIcon.icon.style.borderRadius = '';
  }

  let startTime = Date.now();
  let elapsedTime = 0;

  function updateBorder() {
    elapsedTime = Date.now() - startTime;
    let percentage = Math.min(100, (elapsedTime / toggleDelay) * 100);
    // toggleIcon.style.border = `2px solid transparent`;
    // toggleIcon.style.borderImage = `linear-gradient(90deg, #fff ${percentage}%, #F6F5F233 ${percentage}%) 2 stretch`;

    if (elapsedTime < toggleDelay) {
      requestAnimationFrame(updateBorder);
    }
  }

  updateBorder();

  prevIcon.icon = toggleIcon;
}

function startAutoToggle() {
  intervalId = setInterval(() => {
    currentIndex = (currentIndex + 1) % toggleItems.length;
    toggleHandler(toggleItems[currentIndex].dataset.index, toggleItems);
    toggleHandler(toggleItems[currentIndex].dataset.index, toggleImages);
  }, toggleDelay);
}


function stopAutoToggle() {
  clearInterval(intervalId);
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

toggleItems.forEach((item, index) => {
  item.addEventListener('click', () => {
    // stopAutoToggle();
    currentIndex = index;
    toggleHandler(item.dataset.index, toggleItems);
    toggleHandler(item.dataset.index, toggleImages);
    // startAutoToggle();
  });
});


function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top - 100 >= 0
  );
}

// function handleScroll() {
//   if (!isInViewport(toggleSection) && hasScrolled == false) {
//     hasScrolled = true;
//     toggleItems[0].click();
//   }
// }

// handleScroll()
// window.addEventListener('scroll', handleScroll);